import { render, staticRenderFns } from "./DriverPage.vue?vue&type=template&id=4f2833dc&"
import script from "./DriverPage.vue?vue&type=script&lang=js&"
export * from "./DriverPage.vue?vue&type=script&lang=js&"
import style0 from "./DriverPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports